// Services.jsx - Ceylon Wayfinder Premium Taxi Service
import React, { useState } from 'react';
import './services.css';
import { Link } from "react-router-dom";
import {  FaClock, FaCar, FaUsers, FaCheckCircle } from 'react-icons/fa';

import {
FaMapMarkerAlt,
  FaHotel,

} from "react-icons/fa";
import { 
  FaTaxi, FaMapMarkedAlt, 
  FaStar, FaRegClock, FaUserTie, 
  FaShieldAlt, FaCarAlt, FaPhoneAlt
} from 'react-icons/fa';
import { 
  MdAirportShuttle, 
  MdLocalOffer, MdSupportAgent 
} from 'react-icons/md';
import { GiPathDistance } from 'react-icons/gi';
import { IoIosArrowForward } from 'react-icons/io';
import { motion, AnimatePresence } from 'framer-motion';

function Services() {
  const [activeTab, setActiveTab] = useState('taxi');

  const services = [
    {
      id: 'taxi',
      icon: <FaTaxi size={40} />,
      title: "City Taxi Service",
      description: "Reliable point-to-point transportation with professional drivers across Colombo and major cities.",
      features: [
        "24/7 availability",
        "GPS tracking", 
        "Multiple vehicle options",
        "Cashless payments",
        "Professional drivers"
      ],
      image: "/city tour.jpg"
    },
    {
      id: 'airport',
      icon: <MdAirportShuttle size={40} />,
      title: "Airport Transfers",
      description: "Stress-free airport transportation with flight monitoring and meet & greet service.",
      features: [
        "Meet & greet service",
        "Flight tracking",
        "Luggage assistance",
        "Fixed pricing",
        "Free waiting time"
      ],
      image: "/airport.webp"
    },
    {
      id: 'tours',
      icon: <FaMapMarkedAlt size={40} />,
      title: "Custom Tours",
      description: "Tailored sightseeing experiences across Sri Lanka based on your preferences and schedule.",
      features: [
        "Personalized itineraries",
        "Local expert guides",
        "Flexible scheduling",
        "Photo stops",
        "Cultural experiences"
      ],
      image: "/custom.jpg"
    },
    {
      id: 'wedding',
      icon: <FaCarAlt size={40} />,
      title: "Wedding Hire",
      description: "Premium chauffeur services for weddings, ensuring timely and elegant arrivals.",
      features: [
        "Bridal car with decoration",
        "Guest shuttle services",
        "On-time ceremony transfers",
        "Professional chauffeurs",
        "Luxury vehicle options"
      ],
      image: "/wedding.webp"
    }
  ];

  const allFeatures = [
    {
      icon: <FaRegClock size={24} />,
      title: "24/7 Availability",
      description: "Service available round the clock"
    },
    {
      icon: <FaUserTie size={24} />,
      title: "Professional Drivers",
      description: "Licensed and experienced chauffeurs"
    },
    {
      icon: <FaShieldAlt size={24} />,
      title: "Safety First",
      description: "Regular vehicle maintenance"
    },
    {
      icon: <MdLocalOffer size={24} />,
      title: "Competitive Pricing",
      description: "Transparent rates, no hidden fees"
    },
    {
      icon: <GiPathDistance size={24} />,
      title: "Route Optimization",
      description: "Smart routing to save time"
    },
    {
      icon: <MdSupportAgent size={24} />,
      title: "24/7 Support",
      description: "Dedicated customer service"
    }
  ];

  const activeService = services.find(service => service.id === activeTab);

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section
  className="service-hero-section">
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Premium <span>Taxi & Tour</span> Services
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Experience reliable, comfortable transportation across Sri Lanka
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="service-hero-actions"
          >
            <Link to="/booking" className="cta-button primary">
              Book Now <IoIosArrowForward />
            </Link>
            <a href="tel:+94705549750" className="cta-button secondary">
              <FaPhoneAlt /> Call Us
            </a>
          </motion.div>
        </div>
 
      </section>

      {/* Service Tabs Section */}
      <section className="service-tabs-section">
        <div className="service-container">
          <h2>Our Premium Services</h2>
          <p className="section-subtitle">Choose your perfect travel solution</p>
          
          <div className="service-tabs">
            {services.map((service) => (
              <button
                key={service.id}
                className={`tab-button ${activeTab === service.id ? 'active' : ''}`}
                onClick={() => setActiveTab(service.id)}
              >
                <div className="tab-icon">{service.icon}</div>
                <span>{service.title}</span>
              </button>
            ))}
          </div>

          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
              className="service-detail"
            >
              <div className="detail-content">
                <h3>{activeService.title}</h3>
                <p>{activeService.description}</p>
                <ul className="feature-list">
                  {activeService.features.map((feature, index) => (
                    <li key={index}>
                      <FaStar className="feature-bullet" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/booking" className="learn-more-link">
                  Book Now <IoIosArrowForward />
                </Link>
              </div>
              <div className="detail-image">
                <img src={activeService.image} alt={activeService.title} />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>



{/* ===================== SERVICES SECTION ===================== */}
 <section className="cw-services-section">
      <div className="cw-container">

        {/* Header */}
        <div className="cw-section-header">
          {/* <span className="cw-mini-title">SERVICES</span> */}

          {/* <div className="cw-line-wrap">
            <span></span>
            <span></span>
          </div> */}

          {/* <h2>Our Services</h2> */}
        </div>

        {/* Services Grid */}
        <div className="cw-services-grid">

          {/* Card 1 */}
          <div className="cw-service-card">
            <div className="cw-service-content">
              <h3>Transportation & Vehicle Rentals</h3>
              <p>
                Explore Sri Lanka in comfort with private vehicles and drivers.
                Enjoy safe and convenient transport for all destinations.
              </p>
            </div>

            <div className="cw-service-icon">
              <FaCar />
            </div>
          </div>

          {/* Card 2 */}
          <div className="cw-service-card">
            <div className="cw-service-icon">
              <FaUserTie />
            </div>

            <div className="cw-service-content">
              <h3>Friendly Local Guides</h3>
              <p>
                Our expert guides make your journey richer. Learn culture,
                history, and local secrets in your language.
              </p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="cw-service-card">
            <div className="cw-service-content">
              <h3>Find the Perfect Hotel</h3>
              <p>
                We help you book the best hotels in Sri Lanka ranging from
                budget stays to luxury resorts at great rates.
              </p>
            </div>

            <div className="cw-service-icon">
              <FaHotel />
            </div>
          </div>

          {/* Card 4 */}
          <div className="cw-service-card">
            <div className="cw-service-icon">
              <FaMapMarkerAlt />
            </div>

            <div className="cw-service-content">
              <h3>Travel Planning Assistance</h3>
              <p>
                Not sure where to go? We plan your entire trip from locations
                and timing to activities and accommodations.
              </p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="cw-service-card">
            <div className="cw-service-content">
              <h3>Tour Arrangement Services</h3>
              <p>
                Get custom-made tour packages to top Sri Lankan sites.
                We handle routes, stops, and experiences for your trip.
              </p>
            </div>

            <div className="cw-service-icon">
              <FaMapMarkedAlt />
            </div>
          </div>

          {/* Card 6 */}
          <div className="cw-service-card">
            <div className="cw-service-icon">
              <FaUsers />
            </div>

            <div className="cw-service-content">
              <h3>Event & Group Management</h3>
              <p>
                Organizing a trip? We manage group tours, corporate outings,
                and events with full planning and support.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
    


      </section>





      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2>Why Choose Ceylon Wayfinder?</h2>
          <p className="section-subtitle">Our commitment to excellence</p>
          <div className="features-grid">
            {allFeatures.map((feature, index) => (
              <motion.div 
                key={index}
                className="feature-card"
                whileHover={{ y: -5 }}
                transition={{ duration: 0.2 }}
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;